const JSON_CONTENT_TYPE_RE = /\bjson\b/i;

const previewBody = (body) => (
  typeof body === 'string' ? body.slice(0, 160) : ''
);

const bodyLooksLikeJson = (body) => {
  if (typeof body !== 'string') {
    return false;
  }

  const trimmed = body.trim();
  return trimmed.startsWith('{') || trimmed.startsWith('[');
};

export const createApiResponseError = (message, response, details = {}) => {
  const error = new Error(message);
  error.status = response?.status;
  error.statusText = response?.statusText;
  error.contentType = details.contentType;
  error.bodyPreview = details.bodyPreview;
  error.payload = details.payload;
  return error;
};

const getPayloadMessage = (payload) => {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  return payload.message || payload.error || null;
};

export const readJsonResponse = async (
  response,
  {
    errorMessage = 'Request failed',
    allowEmpty = false,
  } = {},
) => {
  const contentType = response?.headers?.get?.('content-type') || '';
  const body = await response.text();

  if (!body || body.trim() === '') {
    if (allowEmpty || response.ok) {
      return null;
    }

    throw createApiResponseError(
      `${errorMessage}: empty response`,
      response,
      { contentType, bodyPreview: '' },
    );
  }

  if (!JSON_CONTENT_TYPE_RE.test(contentType) && !bodyLooksLikeJson(body)) {
    throw createApiResponseError(
      `${errorMessage}: expected JSON response`,
      response,
      { contentType, bodyPreview: previewBody(body) },
    );
  }

  let payload;
  try {
    payload = JSON.parse(body);
  } catch (parseError) {
    throw createApiResponseError(
      `${errorMessage}: invalid JSON response`,
      response,
      { contentType, bodyPreview: previewBody(body), payload: null },
    );
  }

  if (!response.ok) {
    throw createApiResponseError(
      getPayloadMessage(payload) || errorMessage,
      response,
      { contentType, bodyPreview: previewBody(body), payload },
    );
  }

  return payload;
};

export default readJsonResponse;
